import FullPageLoadingIndicatorComponent from './FullPageLoadingIndicatorComponent';


export default FullPageLoadingIndicatorComponent;
